module.exports = __webpack_public_path__ + "static/media/mobile-landing.740fa6c7.png";